var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { MEDIA_QUERIES } from 'shared/style';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import TitleBlock from './TitleBlock';
import ParagraphBlock from './ParagraphBlock';
var GET_LIST_COMPONENT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetListComponent($id: String!, $subpageId: String!) {\n    component(id: $id, subpageId: $subpageId) {\n      id\n      value {\n        title\n        list\n      }\n    }\n  }\n"], ["\n  query GetListComponent($id: String!, $subpageId: String!) {\n    component(id: $id, subpageId: $subpageId) {\n      id\n      value {\n        title\n        list\n      }\n    }\n  }\n"])));
var RootDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", " {\n    max-width: 1200px;\n  }\n  ", " {\n    width: 100%;\n  }\n  padding: 0 20px;\n  margin: 0 auto;\n\n  > .paragraph {\n    ", " {\n      &:not(:first-child) {\n        margin-top: 10px;\n      }\n    }\n  }\n"], ["\n  ", " {\n    max-width: 1200px;\n  }\n  ", " {\n    width: 100%;\n  }\n  padding: 0 20px;\n  margin: 0 auto;\n\n  > .paragraph {\n    ", " {\n      &:not(:first-child) {\n        margin-top: 10px;\n      }\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PHONE);
export default (function (_a) {
    var id = _a.id, subpageId = _a.subpageId;
    return (React.createElement(Query, { query: GET_LIST_COMPONENT, variables: { id: id, subpageId: subpageId } }, function (_a) {
        var loading = _a.loading, error = _a.error, data = _a.data;
        if (loading)
            return React.createElement(Loading, null);
        if (error || !data.component)
            return React.createElement(Error, null);
        var _b = data.component.value, title = _b.title, list = _b.list;
        return (React.createElement(RootDiv, null,
            title && (React.createElement(TitleBlock, { title: title })),
            list.map(function (p, idx) {
                return (React.createElement("div", { key: idx, className: "paragraph" },
                    React.createElement(ParagraphBlock, { paragraph: '• ' + p })));
            })));
    }));
});
var templateObject_1, templateObject_2;
